import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, inject, Injectable } from '@angular/core';
import { EnvConfig, Environment } from '@doc/core';
import { ApiUrls } from '../backoffice-urls';

@Injectable({
  providedIn: 'root'
})
export class WorkflowService {

  private http = inject(HttpClient);
  private apiUrl: string;
  private baseUrl: string;

  constructor(
    @Inject(EnvConfig) private config: Environment,
  ) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  //To list category

  getCatrogyList(body: any) {

    const link = this.apiUrl + ApiUrls.categoryGetList;
    return this.http.post(link, body);
  }


  //To create category
  createCategory(body: any) {
    const link = this.apiUrl + ApiUrls.createCategory;
    return this.http.post<any>(link, body);
  }

  //To get Category by Id
  getCategoryById(id: number) {
    const link = `${this.apiUrl}${ApiUrls.categoryById}/${id}`;
    return this.http.get<any>(link);
  }

  //To update category
  updateCategory(id: number, body: any) {
    const link = `${this.apiUrl}${ApiUrls.updateCategory}/${id}`;
    return this.http.post<any>(link, body);
  }

  //To delete category
  deleteCategory(id: number) {
    const link = `${this.apiUrl}${ApiUrls.deleteCategory}/${id}`;
    return this.http.post<any>(link, id);

  }

  //To list workflow group

  workflowGroupList(body: any) {

    const link = this.apiUrl + ApiUrls.workflowGroupList;
    return this.http.post(link, body);
  }

  //To create workflow group
  createWorkflowGroup(body: any) {
    const link = this.apiUrl + ApiUrls.createWorkflowGroup;
    return this.http.post<any>(link, body);
  }

  //To update workflow group
  updateWorkflowGroup(body: any) {
    const link = this.apiUrl + ApiUrls.updateWorkflowGroup;
    return this.http.post<any>(link, body);
  }

  //To get workflow group by id
  getWorkflowGroupById(id: number) {
    const link = `${this.apiUrl}${ApiUrls.getWorkFlowGroupById}/${id}`;
    return this.http.get<any>(link);
  }


  //To list Workflow
  workflowList(body: any) {

    const link = this.apiUrl + ApiUrls.workFlowList;
    return this.http.post(link, body);
  }

  //To get workflow details group list
  getWorkflowDeatilsGroupList() {
    const link = `${this.apiUrl}${ApiUrls.workflowDetailsGroupList}`;
    return this.http.get<any>(link);
  }

  //To delete workflow groups
  deleteWorkflowGroup(id: number) {
    const link = `${this.apiUrl}${ApiUrls.deleteWorkflowGroup}/${id}`;
    return this.http.post<any>(link, id);
  }

  //To get workflow details category list
  getWorkflowDeatilsCategoryList() {
    const link = `${this.apiUrl}${ApiUrls.workflowDetailsCategoryList}`;
    return this.http.get<any>(link);
  }

  //To get workflow details by id
  getWorkflowetailsById(id: number) {
    const link = `${this.apiUrl}${ApiUrls.worflowDetailsGetById}/${id}`;
    return this.http.get<any>(link);
  }

  getWorkflowById(id: number) {
    const link = `${this.apiUrl}${ApiUrls.getWorkflowById}/${id}`;
    return this.http.get<any>(link);
  }

  //To create workflow details
  createFlowDeatils(body: any) {
    const link = this.apiUrl + ApiUrls.createWorkflow;
    return this.http.post<any>(link, body);
  }

  //To update workflow details
  updateWorkflowDetails(body: any) {
    const link = this.apiUrl + ApiUrls.updateWorkflow;
    return this.http.post<any>(link, body);
  }

  //To delete workflow details
  deleteWorkflow(id: number) {
    const link = `${this.apiUrl}${ApiUrls.deleteWorkflow}/${id}`;
    return this.http.post<any>(link, id);
  }

  getWorkflowActionInbox(body: any = {}) {
    const link = this.apiUrl + ApiUrls.workflowActionInbox;
    return this.http.post<any>(link, body);
  }

  getWorkflowActionOutbox(body: any = {}) {
    const link = this.apiUrl + ApiUrls.workflowActionOutbox;
    return this.http.post<any>(link, body);
  }

  processWorkflowAction(body: {
    fileId: number;
    status: number;
    comment?: string;
    managerId?: number;
    assignedTo?: number;
  }) {
    const link = this.apiUrl + ApiUrls.workflowActionProcess;
    return this.http.post<any>(link, body);
  }

  getManagerList(body: { fileId: number }) {
    const link = this.apiUrl + ApiUrls.workflowActionManagerList;
    return this.http.post<any>(link, body);
  }

  getWorkflowActionLog(options: { fileId?: number; folderId?: number }) {
    const link = this.apiUrl + ApiUrls.workflowActionGetLog;
    let params = new HttpParams();
    const fileId = Number(options.fileId ?? 0);
    const folderId = Number(options.folderId ?? 0);

    if (fileId > 0) {
      params = params.set('fileId', String(fileId));
    }
    if (folderId > 0) {
      params = params.set('folderId', String(folderId));
    }

    return this.http.get<any>(link, { params });
  }

}
